import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {isConnectedCenterMode} from '../../lib/nexus-connected-center';

import styles from './connected-center-status.css';

const ConnectedCenterStatus = ({
    cloudConnectionStatus,
    hasCloudVariables
}) => {
    const ccMode = isConnectedCenterMode();
    if (!ccMode && !hasCloudVariables) {
        return null;
    }

    const isConnected = ccMode || cloudConnectionStatus === 'connected';

    return (
        <div
            className={classNames(styles.status, {
                [styles.statusConnected]: isConnected,
                [styles.statusDisconnected]: !isConnected
            })}
            title="Connected to Connected Center"
        >
            <span
                className={classNames(styles.indicator, {
                    [styles.indicatorFilled]: isConnected
                })}
                aria-hidden
            />
            <FormattedMessage
                defaultMessage="Connected to Connected Center"
                description="Menu bar label when Nexus Blocks is linked to Connected Center"
                id="tw.menuBar.connectedCenterConnected"
            />
        </div>
    );
};

ConnectedCenterStatus.propTypes = {
    cloudConnectionStatus: PropTypes.oneOf(['connected', 'connecting', 'disconnected']),
    hasCloudVariables: PropTypes.bool
};

const mapStateToProps = state => ({
    cloudConnectionStatus: state.scratchGui.tw.cloudConnectionStatus,
    hasCloudVariables: state.scratchGui.tw.hasCloudVariables
});

export default connect(mapStateToProps)(ConnectedCenterStatus);
